export const ONBOARDING_FLOWS = {
  HEATMAPS: 'heatmaps',
  RECORDINGS: 'recordings',
  CONVERSIONS: 'conversions',
  FUNNELS: 'funnels',
  ERRORS: 'errors',
  TRAFFIC_ANALYSIS: 'traffic_analysis',
  SURVEYS: 'surveys',
  CTAS: 'ctas',
  AB_TESTING: 'ab_testing',
  WEB_ANALYTICS: 'web_analytics',
};

export const TECH_RECOMMENDATIONS = {
  NONE: 'manual',
  DRUPAL: 'drupal',
  GTM: 'gtm',
  JOOMLA: 'joomla',
  MAGENTO: 'magento',
  MAGENTO2: 'magento2',
  SEGMENT: 'segment',
  SHOPIFY: 'shopify',
  SQUARESPACE: 'squarespace',
  WIX: 'wix',
  WORDPRESS: 'wordpress',
};

export function normalizeTechRecommendation(recommendation) {
  if (
    !recommendation ||
    recommendation === TECH_RECOMMENDATIONS.NONE ||
    recommendation === TECH_RECOMMENDATIONS.SHOPIFY
  ) {
    return null;
  }

  return recommendation;
}
